module.exports = __webpack_public_path__ + "resources/img/img_datahunt4_m_en.6cbab97c7d950b3b67ed7dd7effa42b8.png";